export default class BaseMetricHandler {
  constructor(groupBy, filterBy) {
    this.groupBy = groupBy;
    this.filterBy = filterBy;
    this.showTotals = true;
  }

  buildGraphOptions(backendData) {}

  static MaxLabels() {
    return 10;
  }

  getTableRepresentation(backendData) {
    let tableRows = [];

    if (backendData.length === 0) {
      return tableRows;
    }

    if (backendData.response_type === "single_value") {
      return [backendData.labels, backendData.data];
    }
    let labels = backendData.labels.slice(0, BaseMetricHandler.MaxLabels());
    let totalCountsRow = Array(labels.length).fill(0);

    tableRows.push(["Label", ...labels]);

    backendData.xAxis.forEach((value, index) => {
      let thisRow = [value];
      labels.forEach((label, labelIndex) => {
        thisRow.push(backendData.data[labelIndex][index]);
        totalCountsRow[labelIndex] +=
          Math.round(
            (backendData.data[labelIndex][index] + Number.EPSILON) * 100
          ) / 100;
      });

      tableRows.push(thisRow);
    });

    if (this.showTotals) {
      tableRows.push(["Total", ...totalCountsRow]);
    }

    return tableRows;
  }
}
